import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

import { useSidebar }      from '../../providers/sidebar';
import { useSiteSettings } from '../../providers/siteSettings';

import CallMeContactsList from '../call-me-contacts-list';
import CheckIcon          from '../icons/CheckIcon';
import CloseIcon          from '../icons/CloseIcon';

const CallMeFormGratitudeModal = function() {
  const { t } = useTranslation();

  const sidebar      = useSidebar();
  const siteSettings = useSiteSettings();

  const [show, setShow] = React.useState(false);
  const modalRef        = React.useRef(null);
  const checkIconRef    = React.useRef(null);

  const closeModal         = React.useCallback(() => {
    if (show) {
      setShow(false);
    }

    sidebar.hideGratitudeModal();
  }, [show]);
  const keyDown            = React.useCallback((event) => {
    if (sidebar.isGratitudeModalOpen && show && event.key === 'Escape') {
      closeModal();
    }
  }, [closeModal, show, sidebar.isGratitudeModalOpen]);
  const handleClickOutside = React.useCallback((event) => {
    if (sidebar.isGratitudeModalOpen && (modalRef.current && !modalRef.current.contains(event.target))) {
      closeModal();
    }
  }, [closeModal, sidebar.isGratitudeModalOpen, modalRef]);

  React.useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show]);
  React.useEffect(() => {
    if (sidebar.isGratitudeModalOpen) {
      if (!show) {
        setTimeout(() => {
          setShow(true);
        }, 100);
      }
    }
  }, [sidebar.isGratitudeModalOpen]);
  React.useEffect(() => {
    document.body.classList.toggle('fixed', sidebar.isGratitudeModalOpen && show);
  }, [sidebar.isGratitudeModalOpen, show]);
  React.useEffect(() => {
    if (!checkIconRef.current) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry && entry.isIntersecting) {
        entry.target.classList.add('animated');
      } else {
        entry.target.classList.remove('animated');
      }
    }, {
      threshold: 0.5,
    });

    observer.observe(checkIconRef.current);

    return () => {
      if (checkIconRef.current) {
        observer.unobserve(checkIconRef.current);
      }
    };
  }, [show, sidebar.isGratitudeModalOpen]);

  return (
    <div className={classNames('modal-overlay', { show })}>
      <div
        className={'gratitude_modal'}
        ref={modalRef}
      >
        <span
          className={'close'}
          onClick={closeModal}
        ><CloseIcon /></span>
        <div className={'modal_container'}>
          <div className={'check_icon_wrapper'}>
            <div
              className={'check_icon_container'}
              ref={checkIconRef}
            ><CheckIcon /></div>
          </div>
          <div className={'description_wrapper'}>
            <p className={'title'}>{t('client_gratitude_modal_title')}</p>
            <p className={'description'}>{t('client_gratitude_modal_description')}</p>
          </div>
          <p className={'working_time'}>{t('client_contact_center_working_time')}{' '}
            <span>{`${t('client_with')} ${siteSettings.data.WORKING_TIME.FROM} ${t('label_to')
              .toLowerCase()} ${siteSettings.data.WORKING_TIME.TO}`}</span></p>
          <CallMeContactsList />
        </div>
      </div>
    </div>
  );
};

export default CallMeFormGratitudeModal;